import React, { useState, useEffect } from 'react';

const HotmessBrandSection = () => {
  const [screenWidth, setScreenWidth] = useState(typeof window !== 'undefined' ? window.innerWidth : 1200);

  useEffect(() => {
    const handleResize = () => {
      setScreenWidth(window.innerWidth);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const getContainerStyle = () => ({
    width: '100vw',
    maxWidth: '100%',
    backgroundColor: '#000000',
    padding: screenWidth < 640 ? '40px 16px' : screenWidth < 1024 ? '60px 32px' : '80px 40px',
    textAlign: 'center',
    position: 'relative',
    overflow: 'hidden',
    boxSizing: 'border-box',
    margin: 0
  });

  const getBrandTitleStyle = () => ({
    fontSize: screenWidth < 375 ? '36px' : 
               screenWidth < 640 ? '48px' : 
               screenWidth < 768 ? '64px' : 
               screenWidth < 1024 ? '72px' : 
               screenWidth < 1440 ? '84px' : '96px',
    fontWeight: '900',
    color: '#e60000',
    letterSpacing: screenWidth < 640 ? '2px' : '4px',
    lineHeight: '1.1',
    marginBottom: screenWidth < 640 ? '24px' : '32px',
    textTransform: 'uppercase',
    maxWidth: '100%',
    wordBreak: 'break-word',
    padding: '0 4px',
    boxSizing: 'border-box'
  });

  const getSubheadingStyle = () => ({
    fontSize: screenWidth < 375 ? '16px' : 
               screenWidth < 640 ? '18px' : 
               screenWidth < 768 ? '20px' : 
               screenWidth < 1024 ? '22px' : '24px',
    fontWeight: '600',
    color: '#FFFFFF',
    letterSpacing: screenWidth < 640 ? '1px' : '2px',
    lineHeight: '1.4',
    marginBottom: screenWidth < 640 ? '16px' : '20px',
    textTransform: 'uppercase',
    maxWidth: '100%',
    padding: '0 4px',
    boxSizing: 'border-box'
  });

  const getDescriptionStyle = () => ({
    fontSize: screenWidth < 375 ? '14px' : 
               screenWidth < 640 ? '15px' : 
               screenWidth < 768 ? '16px' : 
               screenWidth < 1024 ? '17px' : '18px',
    fontWeight: '400',
    color: '#FFFFFF',
    lineHeight: '1.6',
    marginBottom: screenWidth < 640 ? '32px' : '40px',
    maxWidth: screenWidth < 640 ? '100%' : screenWidth < 1024 ? '80%' : '70%',
    margin: `0 auto ${screenWidth < 640 ? '32px' : '40px'} auto`,
    padding: '0 4px',
    boxSizing: 'border-box'
  });

  const getCategoryLinksStyle = () => ({
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'center',
    alignItems: 'center',
    gap: screenWidth < 640 ? '12px' : '16px',
    marginBottom: screenWidth < 640 ? '40px' : '60px',
    padding: '0 4px',
    boxSizing: 'border-box'
  });

  const getCategoryLinkStyle = () => ({
    fontSize: screenWidth < 640 ? '12px' : '14px',
    fontWeight: '700',
    color: '#e60000',
    textTransform: 'uppercase',
    letterSpacing: '1px',
    textDecoration: 'none',
    cursor: 'pointer',
    transition: 'color 0.3s ease',
    whiteSpace: 'nowrap'
  });

  const getSeparatorStyle = () => ({
    color: '#e60000',
    fontSize: screenWidth < 640 ? '12px' : '14px',
    fontWeight: '700'
  });

  const getMottoStyle = () => ({
    fontSize: screenWidth < 375 ? '24px' : 
               screenWidth < 640 ? '28px' : 
               screenWidth < 768 ? '32px' : 
               screenWidth < 1024 ? '36px' : '40px',
    fontWeight: '900',
    color: '#e60000',
    letterSpacing: screenWidth < 640 ? '1px' : '2px',
    lineHeight: '1.2',
    marginBottom: screenWidth < 640 ? '32px' : '40px',
    textTransform: 'uppercase',
    maxWidth: '100%',
    padding: '0 4px',
    boxSizing: 'border-box'
  });

  const getPrimaryButtonStyle = (isHover = false) => ({
    backgroundColor: isHover ? '#e60000' : '#e60000',
    color: '#FFFFFF',
    border: 'none',
    padding: screenWidth < 640 ? '14px 28px' : '16px 32px',
    fontSize: screenWidth < 640 ? '14px' : '16px',
    fontWeight: '700',
    textTransform: 'uppercase',
    letterSpacing: '1px',
    borderRadius: '50px',
    cursor: 'pointer',
    transition: 'all 0.3s ease',
    textDecoration: 'none',
    display: 'inline-block',
    marginBottom: screenWidth < 640 ? '16px' : '20px',
    minWidth: screenWidth < 640 ? '180px' : '200px',
    textAlign: 'center',
    boxShadow: isHover ? '0 8px 25px rgba(255, 107, 53, 0.4)' : '0 4px 15px rgba(255, 107, 53, 0.2)',
    transform: isHover ? 'translateY(-2px)' : 'translateY(0)'
  });

  const getSecondaryButtonStyle = (isHover = false) => ({
    backgroundColor: isHover ? '#e60000' : 'transparent',
    color: isHover ? 'white' : 'white',
    border: `2px solid ${isHover ? '#e60000' : 'white'}`,
    padding: screenWidth < 640 ? '12px 26px' : '14px 30px',
    fontSize: screenWidth < 640 ? '14px' : '16px',
    fontWeight: '700',
    textTransform: 'uppercase',
    letterSpacing: '1px',
    borderRadius: '50px',
    cursor: 'pointer',
    transition: 'all 0.3s ease',
    textDecoration: 'none',
    display: 'inline-block',
    minWidth: screenWidth < 640 ? '180px' : '200px',
    textAlign: 'center',
    boxShadow: isHover ? '0 8px 25px rgba(255, 255, 255, 0.2)' : '0 4px 15px rgba(255, 107, 53, 0.1)',
    transform: isHover ? 'translateY(-2px)' : 'translateY(0)'


    
  });

  const getButtonContainerStyle = () => ({
    display: 'flex',
    flexDirection: screenWidth < 640 ? 'column' : 'column',
    alignItems: 'center',
    gap: screenWidth < 640 ? '16px' : '20px',
    maxWidth: '100%',
    padding: '0 4px',
    boxSizing: 'border-box'
  });

  return (
    <div style={getContainerStyle()}>
      <h1 style={getBrandTitleStyle()}>
        HOTMESS
      </h1>
      
      <h2 style={getSubheadingStyle()}>
        MORE THAN A BRAND
      </h2>
      
      <h3 style={getSubheadingStyle()}>
        IT'S THE GLUE. THE LOOP. THE LEGEND.
      </h3>
      
      <p style={getDescriptionStyle()}>
        Every wild night. Every honest story. Every survivor still standing. HOTMESS holds you together—gym to club, afterparty to aftercare. Fashion that's loud, lube that cares, radio that never shuts up, rewards that pay you back.
      </p>
      
      <div style={getCategoryLinksStyle()}>
        <a href="/" style={getCategoryLinkStyle()}>RECORDS</a>
        <span style={getSeparatorStyle()}>•</span>
        <a href="/" style={getCategoryLinkStyle()}>FASHION</a>
        <span style={getSeparatorStyle()}>•</span>
        <a href="/" style={getCategoryLinkStyle()}>RADIO</a>
        <span style={getSeparatorStyle()}>•</span>
        <a href="/" style={getCategoryLinkStyle()}>CARE</a>
        <span style={getSeparatorStyle()}>•</span>
        <a href="/" style={getCategoryLinkStyle()}>REWARDS</a>
      </div>
      
      <h2 style={getMottoStyle()}>
        NOT PERFECT. JUST ALIVE.<br />
        ALWAYS HOTMESS.
      </h2>
      
      <div style={getButtonContainerStyle()}>
        <a
          href="/"
          style={getPrimaryButtonStyle()}
          onMouseEnter={(e) => {
            Object.assign(e.target.style, getPrimaryButtonStyle(true));
          }}
          onMouseLeave={(e) => {
            Object.assign(e.target.style, getPrimaryButtonStyle(false));
          }}
          onTouchStart={(e) => {
            Object.assign(e.target.style, getPrimaryButtonStyle(true));
          }}
          onTouchEnd={(e) => {
            Object.assign(e.target.style, getPrimaryButtonStyle(false));
          }}
        >
          JOIN THE MESS
        </a>
        
        <a
          href="/"
          style={getSecondaryButtonStyle()}
          onMouseEnter={(e) => {
            Object.assign(e.target.style, getSecondaryButtonStyle(true));
          }}
          onMouseLeave={(e) => {
            Object.assign(e.target.style, getSecondaryButtonStyle(false));
          }}
          onTouchStart={(e) => {
            Object.assign(e.target.style, getSecondaryButtonStyle(true));
          }}
          onTouchEnd={(e) => {
            Object.assign(e.target.style, getSecondaryButtonStyle(false));
          }}
        >
          EARN WITH HOTMESS
        </a>
      </div>
    </div>
  );
};

export default HotmessBrandSection;